import { Headers, RequestOptions } from '@angular/http';

export class JWTUtil {

    public jwt(marinaId?) {
        // create authorization header with jwt token
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser && currentUser.token) {
            const headers = new Headers({ Authorization: 'Bearer ' + currentUser.token });
            headers.append('Accept', 'application/json');
            headers.append('UserId', currentUser.id);

            if (marinaId) {
                headers.append('MarinaId', marinaId);
            }

            return new RequestOptions({ headers });
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/_utils/jwt.util.ts